'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherCheckCircle, FeatherLock } from '@subframe/core';
import { useEffect, useState } from 'react';
import { Button, Dialog } from '@/shared/components/ui';
import type { Apuracao } from '../types';
import { formatarMoedaBR, formatarPeriodoCiclo } from '../utils/apuracaoFormatters';
interface FecharCicloModalProps {
  isOpen: boolean;
  apuracao: Apuracao | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: (cienteEventosRejeitados: boolean) => void;
}
export function FecharCicloModal(t0) {
  const $ = _c(64);
  const {
    isOpen,
    apuracao,
    saving,
    onClose,
    onConfirm
  } = t0;
  const [ciente, setCiente] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (isOpen) {
        setCiente(false);
      }
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!apuracao) {
    return null;
  }
  const temErros = apuracao.eventosRejeitadosCount > 0;
  const podeConfirmar = (!temErros || ciente) && !saving;
  const isConveniado = apuracao.tipoCliente === "CONVENIADO";
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bg-success-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"><FeatherLock className="text-success-600 h-5 w-5" /></div>;
    t4 = <h2 className="text-body-bold font-body-bold text-default-font">Fechar ciclo</h2>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  const t5 = apuracao.tenantNome;
  let t6;
  if ($[5] !== apuracao.periodoFim || $[6] !== apuracao.periodoInicio) {
    t6 = formatarPeriodoCiclo(apuracao.periodoInicio, apuracao.periodoFim);
    $[5] = apuracao.periodoFim;
    $[6] = apuracao.periodoInicio;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== apuracao.tenantNome || $[9] !== t6) {
    t7 = <div className="flex items-start gap-3">{t3}<div>{t4}<p className="text-caption font-caption text-subtext-color mt-1">{t5} ·{" "}{t6}</p></div></div>;
    $[8] = apuracao.tenantNome;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="text-caption font-caption text-subtext-color">Total cobrável</p>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== apuracao.totalCobravel) {
    t9 = formatarMoedaBR(apuracao.totalCobravel);
    $[12] = apuracao.totalCobravel;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <div>{t8}<p className="text-body-bold font-body-bold text-default-font mt-1">{t9}</p></div>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className="text-caption font-caption text-subtext-color">Eventos apurados</p>;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== apuracao.totalEventos) {
    t12 = <div>{t11}<p className="text-body-bold font-body-bold text-default-font mt-1">{apuracao.totalEventos}</p></div>;
    $[17] = apuracao.totalEventos;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== apuracao.eventosNaoCobraveisCount) {
    t13 = apuracao.eventosNaoCobraveisCount > 0 && <div><p className="text-caption font-caption text-subtext-color">Não cobráveis</p><p className="text-body font-body text-default-font mt-1">{apuracao.eventosNaoCobraveisCount} eventos</p></div>;
    $[19] = apuracao.eventosNaoCobraveisCount;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== apuracao.eventosRejeitadosCount || $[22] !== temErros) {
    t14 = temErros && <div><p className="text-caption font-caption text-subtext-color">Eventos rejeitados</p><p className="text-error-700 mt-1 font-medium">{apuracao.eventosRejeitadosCount}</p></div>;
    $[21] = apuracao.eventosRejeitadosCount;
    $[22] = temErros;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t13 || $[27] !== t14) {
    t15 = <div className="grid grid-cols-2 gap-3 rounded-[12px] bg-neutral-50 p-4">{t10}{t12}{t13}{t14}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== apuracao.eventosRejeitadosCount || $[30] !== temErros) {
    t16 = temErros && <div className="border-warning-200 bg-warning-50 flex items-start gap-3 rounded-[8px] border px-4 py-3 text-sm"><FeatherAlertTriangle className="text-warning-700 mt-0.5 h-4 w-4 shrink-0" /><p className="text-warning-800">Este ciclo tem{" "}<span className="font-semibold">{apuracao.eventosRejeitadosCount}</span>{" "}{apuracao.eventosRejeitadosCount === 1 ? "evento rejeitado pendente" : "eventos rejeitados pendentes"}. Eles não serão incluídos neste ciclo se você prosseguir.</p></div>;
    $[29] = apuracao.eventosRejeitadosCount;
    $[30] = temErros;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <FeatherCheckCircle className="text-success-600 mt-0.5 h-4 w-4 shrink-0" />;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  const t18 = isConveniado ? "Ap\xF3s o fechamento, a apura\xE7\xE3o ficar\xE1 imut\xE1vel e ser\xE1 disponibilizada para o M\xF3dulo de Faturas (M5) gerar a pr\xF3xima fatura." : "Esta apura\xE7\xE3o \xE9 apenas para auditoria \u2014 n\xE3o gera fatura. O fechamento marca o ciclo como imut\xE1vel.";
  let t19;
  if ($[33] !== t18) {
    t19 = <div className="flex items-start gap-2 rounded-[8px] bg-neutral-50 px-3 py-2 text-sm text-neutral-700">{t17}<p>{t18}</p></div>;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== apuracao.eventosRejeitadosCount || $[36] !== ciente || $[37] !== temErros) {
    t20 = temErros && <label className="flex cursor-pointer items-start gap-3"><input type="checkbox" checked={ciente} onChange={e => setCiente(e.target.checked)} className="accent-warning-600 mt-0.5 h-4 w-4 rounded border-neutral-300" /><span className="text-sm text-neutral-700">Estou ciente que existem{" "}<span className="font-semibold">{apuracao.eventosRejeitadosCount} eventos rejeitados</span>{" "}— eles não serão incluídos neste ciclo</span></label>;
    $[35] = apuracao.eventosRejeitadosCount;
    $[36] = ciente;
    $[37] = temErros;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== onClose || $[40] !== saving) {
    t21 = <Button variant="neutral-secondary" size="medium" onClick={onClose} disabled={saving}>Cancelar</Button>;
    $[39] = onClose;
    $[40] = saving;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <FeatherLock />;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== ciente || $[44] !== onConfirm) {
    t23 = () => onConfirm(ciente);
    $[43] = ciente;
    $[44] = onConfirm;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  const t24 = !podeConfirmar;
  let t25;
  if ($[46] !== saving || $[47] !== t23 || $[48] !== t24) {
    t25 = <Button variant="brand-primary" size="medium" icon={t22} onClick={t23} loading={saving} disabled={t24}>Fechar ciclo</Button>;
    $[46] = saving;
    $[47] = t23;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t21 || $[51] !== t25) {
    t26 = <div className="flex items-center justify-end gap-2 border-t border-neutral-100 pt-4">{t21}{t25}</div>;
    $[50] = t21;
    $[51] = t25;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t15 || $[54] !== t16 || $[55] !== t19 || $[56] !== t20 || $[57] !== t26 || $[58] !== t7) {
    t27 = <Dialog.Content className="max-w-lg"><div className="flex w-full flex-col gap-5 p-6">{t7}{t15}{t16}{t19}{t20}{t26}</div></Dialog.Content>;
    $[53] = t15;
    $[54] = t16;
    $[55] = t19;
    $[56] = t20;
    $[57] = t26;
    $[58] = t7;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== isOpen || $[61] !== onClose || $[62] !== t27) {
    t28 = <Dialog open={isOpen} onOpenChange={onClose}>{t27}</Dialog>;
    $[60] = isOpen;
    $[61] = onClose;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  return t28;
}